// Async actions
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCategoriesPromise, fetchSoundsPromise, generateGamePromise, /*generateGameUUID,*/
  fetchGamesPromise, fetchAreaOfNeedsPromise,
  fetchThemesPromise, fetchGradesPromise,
  getReadingGamePromise, getSpellingGamePromise,
  fetchCCSSMetaPromise,
} from "@app/routes/vocabulary/api/index";
import { setCCSSMeta, setCategories, setIsLoadingCategories, setSounds } from "@app/routes/treatmentV3/store/activityLibrarySlice";

export const generateGame = createAsyncThunk(
  "vocabulary/generateGame",
  async ({ /*studentId, therpistId, treatmentId,*/ game, filters, successFn, areaOfNeed, protocol, objective }) => {
    // TODO - consider using Promise.all() for asyncing both requests
    const area = [{
      field: areaOfNeed,
      protocol,
      objective,
      //target: "manner",// no target ??
    }];
    
    const measureResponse = { uuid: "error" };
    /*
    try {
      if (studentId) {
        measureResponse = await generateGameUUID({
          studentId,
          gameType: game.title || game.game_type,
          game_id: game.external_id,
          filters,
          therpistId,
          treatmentId,
          area,
        });
      }

    } catch (e) {
      console.error("failed to get UUID");
    }
    */
    const gameResponse = await generateGamePromise({ /*student_id: studentId,*/ game_type: game.game_type, game_id: game.external_id, filters });
    // const wordsResponse = await fetchWordsByFilter({ student_id: studentId, game_type: game.game_type, filters, limit: 20 });
    const game_url = gameResponse?.response?.game_url;
    successFn?.(measureResponse, gameResponse.response, { ...game, game_url }, filters, area);
    return { measureResponse, gameResponse };
  },
);

export const fetchManualGame = createAsyncThunk(
  "vocabulary/fetchManualGame",
  async ({ /*studentId, therpistId, treatmentId,*/ game, successFn, areaOfNeed, protocol, objective, filters }) => {
    const measureResponse = { uuid: "error" };
    const area = [{
      field: areaOfNeed,
      protocol,
      objective,
    }];
    /*
    try {
      if (studentId) {
        measureResponse = await generateGameUUID({
          studentId,
          gameType: game.title || game.game_type,
          game_id: game.external_id,
          therpistId,
          treatmentId,
          filters,
          area,
        });
      }
    } catch (e) {
      console.error("failed to get UUID");
    }
    */
    successFn?.(measureResponse, { id: 300 }, game, filters, area);
    return { measureResponse, game };
  },
);

export const fetchCategories = createAsyncThunk(
  "vocabulary/categories",
  async (_, thunkAPI) => {
    thunkAPI.dispatch(setIsLoadingCategories(true));
    const response = await fetchCategoriesPromise();
    thunkAPI.dispatch(setCategories(response));
    thunkAPI.dispatch(setIsLoadingCategories(false));
    return response;
  },
);

export const fetchSounds = createAsyncThunk(
  "vocabulary/sounds",
  async(_, thunkAPI) => {
    const response = await fetchSoundsPromise();
    thunkAPI.dispatch(setSounds(response));
    return response;
  },
);

export const fetchThemes = createAsyncThunk(
  "vocabulary/themes",
  async() => {
    const response = await fetchThemesPromise();
    return response;
  },
);

export const fetchGrades = createAsyncThunk(
  "vocabulary/grades",
  async() => {
    const response = await fetchGradesPromise();
    return response;
  },
);

export const fetchCCSSMeta = createAsyncThunk(
  "vocabulary/ccssMeta",
  async(_, thunkAPI) => {
    const response = await fetchCCSSMetaPromise();
    thunkAPI.dispatch(setCCSSMeta(response.response));
    return response;
  },
);

export const fetchGames = createAsyncThunk(
  "vocabulary/games",
  async (data) => {
    const response = await fetchGamesPromise(data);
    return response?.response || [];
  },
);

export const fetchAreaOfNeeds = createAsyncThunk(
  "vocabulary/areaOfNeeds",
  async () => {
    const response = await fetchAreaOfNeedsPromise();
    return response?.response || [];
  },
);

export const fetchReadingGame = createAsyncThunk(
  "vocabulary/fetchReadingGame",
  async ({ game, areaOfNeed, protocol, objective, filters, successFn }) => {
    const gameResponse = await getReadingGamePromise(game.external_reading_task_id);
    const measureResponse = { };
    const area = [{ field: areaOfNeed, protocol, objective }];
    
    successFn?.(measureResponse, gameResponse.response, { ...game, ...gameResponse.response }, filters, area);
    return { measureResponse, gameResponse };
  },
);

export const fetchSpellingGame = createAsyncThunk(
  "vocabulary/fetchSpellingGame",
  async ({ game, areaOfNeed, protocol, objective, filters, successFn }) => {
    const gameResponse = await getSpellingGamePromise(game.external_spelling_task_id);
    const measureResponse = { };
    const area = [{ field: areaOfNeed, protocol, objective }];
    
    successFn?.(measureResponse, gameResponse.response, { ...game, ...gameResponse.response }, filters, area);
    return { measureResponse, gameResponse };
  },
);
